import React, { useCallback } from "react";
import "react-data-table-component-extensions/dist/index.css";
import { Button, Card, Col } from "react-bootstrap";
import { StandingUserTable } from "../allTables/allTable";
import StandingService from "../../services/standing.service";
import { useEffect } from "react";
import { useState } from "react";
import * as XLSX from "xlsx";
import * as yup from "yup";
import { AddStanding, DeleteStandingModule } from "../modals/allModal";
import { useFormik } from "formik";
import { enqueueSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import ColorCodeService from "../../services/coloeCode.service";

const schema = yup.object().shape({
  data: yup.mixed().required("Please Upload Your Data"),
  season: yup.string().required("Please select a season"),
});

export function Standing() {
  const location = useLocation();
  const selectedType = location.search.split("=")[1];
  console.log("🚀 ~ Standing ~ selectedType:", selectedType)
  const [data, setData] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [deleteModal, setDeleteModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loader, setLoader] = useState(false);
  const [totalRows, setTotalRows] = useState("");
  const [progress, setProgress] = useState(0);
  const handleDialogClose = () => setModalShow(false);
  const handleDeleteClose = () => setDeleteModal(false);
  const [search, setSearch] = useState("");
  const [getSeasonName, setGetSeasonName] = useState("");
  // console.log("🚀 ~ Standing ~ getSeasonName:", getSeasonName)

  useEffect(() => {
    const getSeasonName = async () => {
      const response = await ColorCodeService.GetAllColorCodeSeasonName(selectedType?.toUpperCase());
      const seasonNames = response.data.data.map(item => item.seasonName);
      setGetSeasonName(seasonNames);
    };
    getSeasonName();
  }, [selectedType]);

  const getAllStanding = async () => {
    setIsLoading(true);
    try {
      const response = await StandingService.getAllStanding(
        search,
        pageNumber,
        dataPerPage,
        selectedType?.toUpperCase()
      );
      setData(response.data.data);
      setTotalRows(response.data.documentCount);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePerPageChange = async (newPerPage, newPageNumber) => {
    setIsLoading(true);
    setDataPerPage(newPerPage);
    setPageNumber(newPageNumber);
    await getAllStanding();
    setIsLoading(false);
  };

  const handlePageChange = async (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    setIsLoading(false);
  };

  useEffect(() => {
    getAllStanding();
  }, [pageNumber, dataPerPage, search, selectedType]);

  const handleOpen = async () => {
    setModalShow(true);
    formik.setFieldValue("data", "");
  };

  const initialValue = {
    data: "",
    seasonName: "",
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];

    if (!file || !file.name.endsWith(".xlsx")) {
      enqueueSnackbar(
        "Invalid File Type! Only Excel files (XLSX) are allowed.",
        {
          variant: "error",
        }
      );
      return;
    }
    const reader = new FileReader();
    reader.onload = async function (e) {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
      formik.setFieldValue("data", sheetData);
    };

    reader.readAsArrayBuffer(file);
  };

  const submit = useCallback(
    async (values, action) => {
      try {
        setLoader(true);
        const sheetData = values.data;
        
        // Replace "-" values with 0 in the data
        const processedData = sheetData.map(row => {
          const processedRow = {};
          Object.keys(row).forEach(key => {
            const value = row[key];
            if (value === "-") {
              processedRow[key] = 0;
            } else {
              processedRow[key] = value;
            }
          });
          
          // If movement key is not available, set it to empty string
          if (!processedRow.hasOwnProperty('movement')) {
            processedRow.movement = "";
          }
          
          // If number key is not available, set it to 0
          if (!processedRow.hasOwnProperty('number')) {
            processedRow.number = 0;
          }
          
          return processedRow;
        });
        
        const chunkSize = 50;
        const headerRow = processedData[0]; // Extract the first row as header
        const totalChunks = Math.ceil(processedData.length / chunkSize);
        for (let i = 0; i < processedData.length; i += chunkSize) {
          const chunk =
            i === 0
              ? processedData.slice(i, i + chunkSize)
              : [headerRow, ...processedData.slice(i, i + chunkSize)]; // Prepend header to each chunk
          try {
            await StandingService.CreateStanding({
              data: chunk,
              type: selectedType?.toUpperCase(),
              seasonName: values.season,
            });
            setProgress(((i + chunkSize) / processedData.length) * 100);
          } catch (error) {
            enqueueSnackbar("Error uploading batch: " + (i / chunkSize + 1), {
              variant: "error",
            });
            setLoader(false);
            setModalShow(false);
          }
        }
        setLoader(false);
        setModalShow(false);
        getAllStanding();
        action.resetForm();
        formik.resetForm();
      } catch (error) {
        enqueueSnackbar(
          error.response.data.message ===
            "Duplicate standing data. Upload not allowed."
            ? "Same Data Not Allowed"
            : "Something Wrong",
          {
            variant: "error",
          }
        );
        setLoader(false);
      }
    },
    [getAllStanding]
  );

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });
  const handleDelete = () => {
    setDeleteModal(true);
  };

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card className="custom-card">
            <Card.Body>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Total Standings
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fa fa-users icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalRows}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col sm={12} md={6} lg={6} xl={6} className="ms-auto mt-auto">
          <div
            className="custom-card text-end  pointer"
            style={{ marginRight: "18px" }}>
            <Button
              className="text-white"
              style={{ marginBottom: "5px", marginLeft: "15px" }}
              onClick={() => handleOpen("")}>
              <i className="fas fa-plus"></i> &nbsp; Add Standing Data
            </Button>
            <Button
              className="text-white"
              variant="danger"
              style={{ marginBottom: "5px", marginLeft: "15px" }}
              onClick={() => handleDelete("")}>
              <i className="fas fa-trash"></i> &nbsp; {selectedType?.toUpperCase() === "F1" ? "Delete All F1 Standing Data" : "Delete All motoGP Standing Data"}
            </Button>
            {modalShow && (
              <AddStanding
                show={modalShow}
                progress={progress}
                onHide={handleDialogClose}
                formik={formik}
                loader={loader}
                handleFileUpload={handleFileUpload}
                getSeasonName={getSeasonName}
            

              />
            )}
            {deleteModal && (
              <DeleteStandingModule
                show={deleteModal}
                onHide={handleDeleteClose}
                formik={formik}
                getAllStanding={getAllStanding}
                selectedType={selectedType}
              />
            )}
          </div>
        </Col>
      </div>

      <StandingUserTable
        data={data}
        selectedType={selectedType}
        handleSearchData={(e) => setSearch(e.target.value)}
        totalRows={totalRows}
        handlePageChange={handlePageChange}
        dataPerPage={dataPerPage}
        isLoading={isLoading}
        setDataPerPage={setDataPerPage}
        getAllStanding={getAllStanding}
      />
    </>
  );
}
